import React, { useEffect, useState } from 'react';
import { Container } from "react-bootstrap";
import '../Style/ContactUs.css';

// Helpers
import axios from '../Helpers/Axios';
import JwtService from '../Core/Services/JwtService';
import Toast from '../Helpers/Toast'
import Loader from '../Helpers/Loader'
import scrollToTop from '../Helpers/ScrollToTop'
import Swal from 'sweetalert2'

import { Helmet } from 'react-helmet'

const  ContactUs = () => {

    // States
    const [ loading, setLoading ] = useState(false);

    const [ name, setName ] = useState({
        value : '',
        error : null,
    });
    const [ email, setEmail ] = useState({
        value : '',
        error : null,
    });
    const [ phone, setPhone ] = useState({
        value : '',
        error : null,
    });
    const [ address, setAddress ] = useState({
        value : '',
        error : null,
    });
    const [ subject, setSubject ] = useState({
        value : '',
        error : null,
    });
    const [ message, setMessage ] = useState({
        value : '',
        error : null,
    });

    useEffect(() => {

        scrollToTop();

    }, []);

    const changeName = async (e) => {
        let name = e.target.value

        setName((prevState) => ({
            ...prevState,
            value : name
        }))
    }

    const changeEmail = async (e) => {
        let email = e.target.value

        setEmail((prevState) => ({
            ...prevState,
            value : email
        }))
    }

    const changeAddress = async (e) => {
        let address = e.target.value

        setAddress((prevState) => ({
            ...prevState,
            value : address
        }))
    }


    const changeSubject = async (e) => {
        let subject = e.target.value

        setSubject((prevState) => ({
            ...prevState,
            value : subject
        }))
    }

    const changePhone = async (e) => {
        let phone = e.target.value

        setPhone((prevState) => ({
            ...prevState,
            value : phone
        }))
    }

    const changeMessage = async (e) => {
        let message = e.target.value

        setMessage((prevState) => ({
            ...prevState,
            value : message
        }))
    }

    // Reset All
    const resetFields = async () => {
        setName((prevState) => ({
            value : '',
            error : null
        }))
        setEmail((prevState) => ({
            value : "",
            error : null
        }))
        setAddress((prevState) => ({
            value : "",
            error : null
        }))
        setPhone((prevState) => ({
            value : "",
            error : null
        }))
        setSubject((prevState) => ({
            value : "",
            error : null
        }))
        setMessage((prevState) => ({
            value : "",
            error : null
        }))
    } 

    const resetErrors = async () => {
        setName((prevState) => ({
            ...prevState,
            error : null
        }))
        setEmail((prevState) => ({
            ...prevState,
            error : null
        }))
        setAddress((prevState) => ({
            ...prevState,
            error : null
        }))
        setPhone((prevState) => ({
            ...prevState,
            error : null
        }))
        setSubject((prevState) => ({
            ...prevState,
            error : null
        }))
        setMessage((prevState) => ({
            ...prevState,
            error : null
        }))
    }


    // Create Enquiry
    const sendEnquiry = async (e) => {
        e.preventDefault();

        setLoading(true)

        await resetErrors();

        const { data } = await axios.post('v1/auth/enquiry/store', {
            type : 'contact',
            name : name.value,
            email : email.value,
            address : address.value,
            subject : subject.value,
            phone : Number(phone.value),
            message : message.value,
        })


        if(!data.status){
                setLoading(false)

            const { email, name, address, phone, subject, message } = data.data
                
            if(email){
                setEmail((prevState) => ({
                    ...prevState,
                    error : email[0]
                }))
                // Toast.fire({
                //     icon: 'error',
                //     title: `${email[0]}`
                // })
            }

            if(name){
                setName((prevState) => ({
                    ...prevState,
                    error : name[0]
                }))
                // Toast.fire({
                //     icon: 'error',
                //     title: `${name[0]}`
                // })
            }

            if(address){
                setAddress((prevState) => ({
                    ...prevState,
                    error : address[0]
                }))
                // Toast.fire({
                //     icon: 'error',
                //     title: `${address[0]}`
                // })
            }

            if(phone){
                setPhone((prevState) => ({
                    ...prevState,
                    error : phone[0]
                }))
                // Toast.fire({
                //     icon: 'error',
                //     title: `${phone[0]}`
                // })
            }

            if(subject){
                setSubject((prevState) => ({
                    ...prevState,
                    error : subject[0]
                }))
                // Toast.fire({
                //     icon: 'error',
                //     title: `${subject[0]}`
                // })
            }

            if(message){
                setMessage((prevState) => ({
                    ...prevState,
                    error : message[0]
                }))
                // Toast.fire({
                //     icon: 'error',
                //     title: `${message[0]}`
                // })
            }

            

            return;
        }

        scrollToTop();

        resetFields();
        
        Swal.fire({
            icon: 'success',
            title: `Your enquiry was successful. We will be in touch  with you later.`
        })

        setLoading(false)


    }



    return (
        <>
            <Helmet>
                <meta charSet='utf-8' />
                <title>Krayr - Contact Us</title>
            </Helmet>
            <div className='my-4'>

                {loading && <Loader />}
                <Container>
                    <div className='map pt-5'>
                        <div className='row'>
                            <div className='col-lg-8 col-12'>
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1221.848513275266!2d20.998455158304346!3d52.23072204494014!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471ecc7e93007aa7%3A0x3c26a3ff9cecc918!2s00-823%20Warsaw%2C%20Poland!5e0!3m2!1sen!2snp!4v1661316086050!5m2!1sen!2snp" style={{ width:'100%', border:'0', height:'400px'}}></iframe>
                            </div>
                            <div className='col-lg-4 col-12  p-1'>
                                <div className='row pt-2'>
                                    <div className='col-6 col-lg-6 text-center '>
                                         <i className="bi bi-telephone-fill contact-info-i"></i><br></br>
                                         <span className='contact-info-span'>CONTACT US</span>
                                     </div>
                                     <div className='col-6 col-lg-6 border-start'>
                                        <span>+48 579 218 740</span><br></br>
                                        <span>+48 579 218 740</span>
                                      </div>
                                </div>
                                <div className='row pt-5'>
                                    <div className='col-6 col-lg-6 text-center'>
                                         <i className="bi bi-geo-alt-fill contact-info-i"></i><br></br>
                                         <span className='contact-info-span'>ADDRESS</span>
                                       
                                     </div>
                                     <div className='col-6 col-lg-6 border-start'>
                                        <span>+al.Jana PawlaII/lok.1013</span><br></br>
                                        <span>00-823 Warsaw, Poland</span>
                                      </div>
                                </div>
                                <div className='row pt-5'>
                                    <div className='col-6 col-lg-6 text-center'>
                                         <i className="bi bi-envelope-fill contact-info-i"></i><br></br>
                                         <span className='contact-info-span'>EMAIL</span>
                                        
                                     </div>
                                     <div className='col-6 col-lg-6 border-start'>
                                        <span>admin@krayrpol.pl</span><br></br>
                                        <span>info@krayrpol.pl</span>
                                      </div>
                                </div>
                                <div className='row pt-5'>
                                    <div className='col-6 col-lg-6 text-center  contact-info-i'>
                                    <i className="fa fa-fax"></i><br></br>
                                    <span className='contact-info-span'>FAX</span>
                                       
                                     </div>
                                     <div className='col-6 col-lg-6 border-start'>
                                        <span>admin@krayrpol.pl</span><br></br>
                                        <span>info@krayrpol.pl</span>
                                      </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                        
                    <div className='contact-us mt-5'>
                        <h4 className='text-center m-0 p-0'>Contact Us</h4>
                        {/* <p className='text-left pt-2 text-sm'>Give us a call, we endeavour to answer all enquiries.</p> */}
                        <form onSubmit={sendEnquiry}>
                            <div className='row'>
                            <div className="form-group mt-2 col-lg-6 col-12">
                                <label>Full Name</label>
                                <input 
                                    value={name.value}
                                    onChange={changeName}
                                    type="text" className="form-control py-2  "  placeholder="Full Name "/>
                                <p className='mt-2 text-left text-danger'>{ name?.error }</p>
                            </div>
                            <div className="form-group  mt-2 col-lg-6 col-12">
                            <label>Address</label>
                                <input 
                                    value={address.value}
                                    onChange={changeAddress}
                                    type="text" className="form-control py-2 "  placeholder="Address"/>
                                <p className='mt-2 text-left text-danger'>{ address?.error }</p>
                            </div>

                            <div className="form-group  mt-2 col-lg-6 col-12">
                            <label>Phone No</label>
                                <input 
                                    value={phone.value}
                                    onChange={changePhone}
                                    type="number" className="form-control py-2 "  placeholder="Phone Number "/>
                                <p className='mt-2 text-left text-danger'>{ phone?.error }</p>
                            </div>
                           
                            <div className="form-group col-lg-6 col-12 mt-2">
                            <label>Email</label>
                                <input 
                                    value={email.value}
                                    onChange={changeEmail}
                                    type="email" className="form-control py-2 "  placeholder="Email"/>
                                <p className='mt-2 text-left text-danger'>{ email?.error }</p>
                            </div>

                          

                            

                            <div className="form-group  mt-2 col-lg-6 col-12">
                            <label>Subject</label>

                                <input 
                                    value={subject.value}
                                    onChange={changeSubject}
                                    type="text" className="form-control py-2 "  placeholder="Subject"/>
                                <p className='mt-2 text-left text-danger'>{ subject?.error }</p>
                            </div>
                            
                 
                            <div className="form-group mt-2">
                                <label>Message</label>
                                <textarea 
                                    value={message.value}
                                    onChange={changeMessage}
                                    className="form-control py-2" id="exampleFormControlTextarea1" rows="5" placeholder='Your message'>
                                </textarea>
                                <p className='mt-2 text-left text-danger'>{ message?.error }</p>
                            </div>
                            <div className='Message-btn mt-2'>
                                <button type="submit" className="btn btn-submit px-5 text-white py-3">SEND YOUR MESSAGE</button>
                            </div>
                            </div>
                        </form>
                        
                    </div>
                </Container>
            </div>
        </>
    )
}

export default ContactUs;